export default "__VITE_ASSET__ceb2377a__"